export default function Social() {
    return (
        <>
            <div className="floating-socials">
                <a href="https://www.facebook.com/profile.php?id=100064567997597" target="_blank">
                    <div className="media-icon" id="facebook">
                        <i className="bi bi-facebook"></i>
                    </div>
                </a>
                <a href="https://www.instagram.com/gaocna/" target="_blank">
                    <div className="media-icon" id="instagram">
                        <i className="bi bi-instagram"></i>
                    </div>
                </a>
                <a href="https://www.youtube.com/@georgianapostolicorthodoxc342/featured" target="_blank">
                    <div className="media-icon" id="youtube">
                        <i className="bi bi-youtube"></i>
                    </div>
                </a>
            </div>
        </>
    )
}